import React from 'react';
import { CheckIcon, DownloadIcon, GiftIcon } from 'lucide-react';
import { CheckoutButton } from '../CheckoutButton';
import { CollectionMockup } from '../CollectionMockup';
import { OFFER_FEATURES } from '../../data/collection';
import { LAUNCH_LABEL, OFFER_BUY_LABEL, PRICE } from '../../data/checkout';
export function OfferSection() {
  return <section id="oferta" aria-labelledby="oferta-title" className="w-full bg-ivory-deep" data-id="element-262" data-mp="aijtybs9g671">
      <div className="mx-auto max-w-6xl px-5 py-14 sm:px-8 lg:py-24" data-id="element-263" data-mp="6irinrbhflxz">
        <div className="grid min-w-0 grid-cols-1 items-center gap-8 rounded-[24px] bg-paper p-5 ring-1 ring-ivory-line sm:gap-10 sm:rounded-[28px] sm:p-8 lg:grid-cols-[minmax(0,1fr)_minmax(0,1fr)] lg:gap-14 lg:p-12" data-id="element-264" data-mp="1pgi27x9k1ei">
          <div className="order-2 min-w-0 lg:order-1" data-id="element-265" data-mp="3nz10b8z33sgq">
            <CollectionMockup className="max-w-[min(320px,100%)] lg:max-w-[600px]" data-id="element-266" data-mp="3iyd7qiv7j3ke" />
          </div>

          <div className="order-1 min-w-0 lg:order-2" data-id="element-267" data-mp="3ex9pxqtlmxgj">
            <p className="inline-flex items-center rounded-full bg-coral-deep px-4 py-2 text-[0.85rem] font-extrabold uppercase tracking-[0.08em] text-white" data-id="element-268" data-mp="3exta7e6q1xxq">
              {LAUNCH_LABEL}
            </p>

            <div id="offer-price" className="mt-5" data-id="element-269" data-mp="1fktrcpk76pbi">
              <p className="text-[1rem] text-graphite-soft" data-id="element-270" data-mp="10um7q6igf098">
                Precio de referencia <span className="font-semibold line-through" data-id="element-271" data-mp="15snyldm4g3v9">{PRICE.compareAtLabel}</span>
              </p>
              <p className="mt-1 flex flex-wrap items-baseline gap-x-3 gap-y-1" data-id="element-272" data-mp="1ti0ail8u2q19">
                <span className="font-serif text-[3.3rem] font-semibold leading-none text-graphite sm:text-[3.8rem]" data-id="element-273" data-mp="1yhctguwl3cyk">
                  {PRICE.label}
                </span>
                <span className="text-[1.1rem] font-bold text-graphite" data-id="element-274" data-mp="1kjwkbbmwl534">ARS</span>
              </p>
              <p className="mt-2 text-[1.1rem] font-bold text-graphite" data-id="element-275" data-mp="1oli4zj5oinnv">{PRICE.note}</p>
              <p className="mt-4 inline-flex max-w-full items-center gap-2 rounded-[12px] bg-sage-tint px-4 py-2.5 text-[1rem] leading-snug text-graphite ring-1 ring-inset ring-sage-ink/15" data-id="element-276" data-mp="91dcwsqmyl8w">
                <span aria-hidden className="shrink-0" data-id="element-277" data-mp="2fqe2vxvykwzh">💳</span>
                <span className="min-w-0" data-id="element-278" data-mp="2arkl3t9n2jti">
                  ¡Pagá en <strong className="font-extrabold text-sage-ink" data-id="element-279" data-mp="2atxc0vxdk4ip">2 cuotas sin interés</strong>!
                </span>
              </p>
            </div>

            <h2 id="oferta-title" className="mt-6 flex items-start gap-2.5 font-serif text-[1.55rem] font-semibold leading-tight text-coral-ink text-balance sm:text-[1.85rem]" data-id="element-280" data-mp="210zq0ft6bxfc">
              <GiftIcon className="mt-1 h-6 w-6 shrink-0" aria-hidden data-id="element-281" data-mp="1rzrs3yukkyls" />
              La colección completa + 5 bonos de regalo
            </h2>

            <ul className="mt-5 grid grid-cols-1 gap-x-6 gap-y-2.5 sm:grid-cols-2" data-id="element-282" data-mp="1i36onhy77vk2">
              {OFFER_FEATURES.map(feature => <li key={feature} className="flex items-start gap-2.5 text-[1.02rem] font-semibold text-graphite" data-id="element-283" data-mp="3hf7zp9suic9k">
                  <span className="mt-0.5 flex h-5 w-5 shrink-0 items-center justify-center rounded-full bg-sage-tint" data-id="element-284" data-mp="3chpp7ez6jozg">
                    <CheckIcon className="h-3.5 w-3.5 text-sage-ink" strokeWidth={3} aria-hidden data-id="element-285" data-mp="3kw46gnhwit62" />
                  </span>
                  {feature}
                </li>)}
            </ul>

            <div className="relative mt-6 rounded-[16px] bg-blush px-5 py-5 sm:px-6" data-id="element-286" data-mp="3tslgtoifyn0r">
              <span aria-hidden className="pointer-events-none absolute inset-[6px] rounded-[11px] border border-dashed border-coral/50" data-id="element-287" data-mp="2jfq9mfk9b95" />
              <p className="relative font-serif text-[1.2rem] font-semibold text-graphite" data-id="element-288" data-mp="360o5rzmtfz0p">{PRICE.perModelLead}</p>
              <p className="relative mt-1 font-serif text-[1.65rem] font-semibold leading-tight text-coral-ink sm:text-[1.85rem]" data-id="element-289" data-mp="3azrd5qq9qhbu">
                {PRICE.perModelHighlight}
              </p>
              <p className="relative mt-1.5 text-[0.9rem] font-semibold text-graphite-soft" data-id="element-290" data-mp="qabek9kt5obn">{PRICE.perModelNote}</p>
            </div>

            <div className="mt-7" data-id="element-291" data-mp="v7lg2nlh1qfu">
              <CheckoutButton id="offer-cta" label={OFFER_BUY_LABEL} size="lg" data-id="element-292" data-mp="vapqw3tfzkfh" />
            </div>
            <p className="mt-4 flex items-start gap-2 text-[0.95rem] leading-relaxed text-graphite-soft" data-id="element-293" data-mp="247o55bmr040e">
              <DownloadIcon className="mt-0.5 h-4 w-4 shrink-0 text-sage-ink" aria-hidden data-id="element-294" data-mp="2d6hy8s0vec97" />
              Acceso al enlace de descarga después del pago · Archivos PDF · Sin envío físico
            </p>
          </div>
        </div>
      </div>
    </section>;
}